import React from 'react';
import {useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useTitle from '../../hooks/useTittle';

const AddService = () => {
    useTitle('Add Service');
    const navigate = useNavigate();
    const handleAddToService = (event) => {
        event.preventDefault();
        const form = event.target;
        const name = form.name.value
        const details = form.details.value;
        const price = form.price.value;
        const image = form.imageLink.value;
        const rating = 5;
        const food = {name, details, image, price, rating};
        console.log(food);

        fetch('https://salma-kitchen-server.vercel.app/add-service', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(food)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
            if(data.acknowledged){
                toast("Service Added.")
                form.reset();
                navigate(`/foods`)
                }
            })


    }
    return (
        <div className='reg-background py-24'>
            <div className='reg-background-overlay'></div>
            <form onSubmit={handleAddToService} className='px-3'>
                <div className="card sm:w-full md:w-2/5 bg-base-100 shadow-xl mx-auto">
                    <div className="card-body">
                        <h1 className='text-center my-12 sm:text-2xl md:text-4xl font-bold'>Add a new food Item</h1>
                        <div className="form-control w-full">
                            <label className="label">
                                <span className="label-text  md:text-2xl">Name of Food</span>
                            </label>
                            <input required name='name' type="text" placeholder="Type a meaningful & short name" className="input input-bordered w-full" />
                        </div>
                        <div className="form-control">
                            <label className="label">
                                <span className="label-text text-2xl">Details</span>
                            </label>
                            <textarea required name='details' className="textarea textarea-bordered h-24" placeholder="Type description here..."></textarea>
                        </div>
                        <div className="form-control w-full">
                            <label className="label">
                                <span className="label-text  md:text-2xl">Price</span>
                            </label>
                            <input required name='price' type="link" placeholder="$10, $26, $30.99...." className="input input-bordered w-full" />
                        </div>
                        <div className="form-control w-full">
                            <label className="label">
                                <span className="label-text  md:text-2xl">Add photo</span>
                            </label>
                            <input required name='imageLink' type="link" placeholder="Insert a photo URL" className="input input-bordered w-full" />
                        </div>

                        <div className='mt-3'>
                            <button type='submit' className="btn w-full">Submit</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddService;